import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';

import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { CookieService } from 'ngx-cookie-service';
import { Injector } from "@angular/core";
import { Router } from '@angular/router';
import { AuthServiceTonic } from './services/auth-tonic.service';
import { User } from 'oidc-client-ts';
import { SessionService } from "src/app/services/session.service";
import { ConfigService } from './services/config.service';
import { environment } from '../environments/environment';

@Injectable()
export class StartupService {

    constructor(private readonly inj: Injector, private authService: AuthService, private authServiceTonic: AuthServiceTonic, private userService: UserService, private cookieService: CookieService, private config: ConfigService) { }

    public authenticationFailed = false;
    public authErrorStatusCode;

    async load(): Promise<any> {
        const session = this.inj.get(SessionService);
        //let siteUrl = window.location.origin;
        
          console.log("isgame from authservice",this.authService.isGame);
        await this.authService.setupAuth();

                console.log("before checking code in startup");
                if (window.location.href.indexOf("code") != -1) {

                    console.log("i am inside dealers bloack to pickup dealers auth");
                    //let code = window.location.href.match(new RegExp("code=" + "(.*)" + "&"))[1];
                    //let code = window.location.href.split("&code=")[1];
                    let code = window.location.href.match(new RegExp("code=" + "(.*)" + "&"))[1];

                    return this.userService.getUserToken(code,this.authService.isGame).toPromise().then(async (tokenResult: any) => {
                        this.authService._setAuthHeaders(tokenResult);

                        let userSettings = {
                            id_token: tokenResult.id_token,
                            expires_at: tokenResult.profile.exp,
                            refresh_token: tokenResult.refresh_token,
                            scope: tokenResult.scope,
                            token_type: tokenResult.token_type,
                            profile: {
                                iss: tokenResult.profile.iss,
                                sub: tokenResult.profile.sub,
                                aud: tokenResult.profile.aud,
                                exp: tokenResult.profile.exp,
                                iat: tokenResult.profile.iat,
                            },
                            access_token: tokenResult.access_token,
                            state: '',
                            session_state: null
                        }
                        let newUser = new User(userSettings);

                        this.authService.mgr.storeUser(newUser).then(() => {
                            return this.userService.loadUser().toPromise().then((val) => {
                                if (!val) {
                                    this.cookieService.set("deepLink", "LOAD_USER_ERROR")
                                }
                                window.location.href = window.location.href.substring(0, window.location.href.indexOf('?'));
                                return true;
                            }).catch(() => this.cookieService.set("deepLink", "LOAD_USER_ERROR"));
                        });
                    }).catch(() => Promise.resolve());
                }

                this.cookieService.set("deepLink", window.location.href);

                return this.authService.beginLogin().then(user => {
                    console.log("afterbeginlogin");
                    return this.userService.loadUser().toPromise().catch(() => Promise.resolve());
                }).catch(error => {
                    console.log('error in startup service for external', error)
                    if (error.status !== 403) {
                        this.authenticationFailed = true;
                        this.authErrorStatusCode = error.status;
                    }
                });
                // tonic auth
            //}
            // else {
            //     console.log("in tonic block");
            //     if (window.location.href.indexOf("tonic_id") != -1 || window.location.href.indexOf("admin") != -1) {
            //         return this.authServiceTonic.beginLogin().then((gmid) => {
            //             // Once beginLogin is complete, call finishLogin
            //             return this.authServiceTonic.finishLogin().then((gmidFinish) => {
            //                 return this.userService.loadTonicUser().toPromise().then((user) => {
            //                 }).catch(error => {
            //                     console.log('error in startup service for tonic', error)
            //                     if (error.status !== 403) {
            //                         this.authenticationFailed = true;
            //                         this.authErrorStatusCode = error.status;
            //                     }
            //                 });
            //             }).catch(finishError => {
            //                 console.log('Error in finishLogin:', finishError);
            //                 this.authenticationFailed = true;
            //             });
            //         }).catch(beginError => {
            //             console.log('Error in beginLogin:', beginError);
            //             this.authenticationFailed = true;
            //         });
            //     }
            // }
        //}
    // else {
    //         console.log("in 2nd tonic block");
    //         if (window.location.href.indexOf("tonic_id") != -1 || window.location.href.indexOf("admin") != -1) {
    //             return this.authServiceTonic.beginLogin().then((gmid) => {
    //                 // Once beginLogin is complete, call finishLogin
    //                 return this.authServiceTonic.finishLogin().then((gmidFinish) => {
    //                     return this.userService.loadTonicUser().toPromise().then((user) => {
    //                     }).catch(error => {
    //                         console.log('error in startup service for tonic', error)
    //                         if (error.status !== 403) {
    //                             this.authenticationFailed = true;
    //                             this.authErrorStatusCode = error.status;
    //                         }
    //                     });
    //                 }).catch(finishError => {
    //                     console.log('Error in finishLogin:', finishError);
    //                     this.authenticationFailed = true;
    //                 });
    //             }).catch(beginError => {
    //                 console.log('Error in beginLogin:', beginError);
    //                 this.authenticationFailed = true;
    //             });
    //         }
    //     }

    }

}
